module.exports = function() {
  return new Worker(__webpack_public_path__ + "8eb10c1143b815901c8c.worker.js");
};